import React from 'react';
import { SearchIcon } from 'lucide-react';
import { SAMPLE_ROSTER } from '../../../data/academyAdmin';
import { useAcademyHub } from '../../../context/AcademyHub';
import { inputClass } from '../../ui/Field';
import type { AcademyRole } from '../../../types/academyHub';
const ROLES: {
  id: AcademyRole;
  label: string;
}[] = [{
  id: 'learner',
  label: 'Learner'
}, {
  id: 'instructor',
  label: 'Instructor'
}, {
  id: 'moderator',
  label: 'Moderator'
}, {
  id: 'admin',
  label: 'Platform admin'
}];
export function AdminUsers() {
  const {
    hub,
    setRole
  } = useAcademyHub();
  const [query, setQuery] = React.useState('');
  const [roleFilter, setRoleFilter] = React.useState<AcademyRole | ''>('');
  const q = query.trim().toLowerCase();
  const users = SAMPLE_ROSTER.map(u => ({
    ...u,
    role: hub.roleOverrides[u.email] ?? u.role
  })).filter(u => (!roleFilter || u.role === roleFilter) && (!q || u.name.toLowerCase().includes(q) || u.email.includes(q) || u.organisation.toLowerCase().includes(q)));
  return <div data-id="element-307" data-mp="1q7u0ojk2jggv">
      <div className="flex flex-col gap-3 sm:flex-row" data-id="element-308" data-mp="1q83uki88i7ru">
        <div className="relative sm:w-80" data-id="element-309" data-mp="1v76vprl3ftuj">
          <SearchIcon className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted" aria-hidden="true" data-id="element-310" data-mp="1v5vil15rd9qr" />
          <label htmlFor="user-search" className="sr-only" data-id="element-311" data-mp="248egr7ylmy6o">Search users</label>
          <input id="user-search" type="search" value={query} onChange={e => setQuery(e.target.value)} placeholder="Name, email or organisation" className={`${inputClass} py-2 pl-9 text-[14px]`} data-id="element-312" data-mp="246af6wo6ab9k" />
        </div>
        <label htmlFor="role-filter" className="sr-only" data-id="element-313" data-mp="1gislgvlcl33y">Role</label>
        <select id="role-filter" value={roleFilter} onChange={e => setRoleFilter(e.target.value as AcademyRole | '')} className={`${inputClass} w-auto py-2 text-[14px]`} data-id="element-314" data-mp="1ghhi2wvtdxdd">
          <option value="" data-id="element-315" data-mp="nt3kujcjv52v">All roles</option>
          {ROLES.map(r => <option key={r.id} value={r.id} data-id="element-316" data-mp="sspuyjx3057g">{r.label}</option>)}
        </select>
      </div>

      <div className="mt-5 overflow-x-auto rounded-md border border-line" data-id="element-317" data-mp="1w3lscl65f17n">
        <table className="w-full min-w-[720px] text-left text-[14px]" data-id="element-318" data-mp="1r528cqb47zhx">
          <thead className="bg-panel text-small text-muted" data-id="element-319" data-mp="1r4shz1m5rqbp">
            <tr data-id="element-320" data-mp="24wp7qz0cto4x">
              <th scope="col" className="px-4 py-3 font-medium" data-id="element-321" data-mp="24v5qb52yp71k">User</th>
              <th scope="col" className="px-4 py-3 font-medium" data-id="element-322" data-mp="20ulq1sn3dnb7">Organisation</th>
              <th scope="col" className="px-4 py-3 font-medium" data-id="element-323" data-mp="1d4zr96amta3q">Courses</th>
              <th scope="col" className="px-4 py-3 font-medium" data-id="element-324" data-mp="1d7478mlt1zkd">Last active</th>
              <th scope="col" className="px-4 py-3 font-medium" data-id="element-325" data-mp="188110yu39nat">Role</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-line" data-id="element-326" data-mp="1m78ztqmcateh">
            {users.map(u => <tr key={u.email} data-id="element-327" data-mp="1h5bduomk1khu">
                <td className="px-4 py-3" data-id="element-328" data-mp="2xl4gx4wt1c8c">
                  <span className="block text-ink" data-id="element-329" data-mp="2xk37t5zcmzt9">{u.name}</span>
                  <span className="text-small text-muted" data-id="element-330" data-mp="2sm9zo7ehjvqc">{u.email}</span>
                </td>
                <td className="px-4 py-3 text-body" data-id="element-331" data-mp="313212tqcmrpq">
                  {u.organisation}
                  <span className="block text-small text-muted" data-id="element-332" data-mp="315emjgvbfk7j">{u.country}</span>
                </td>
                <td className="px-4 py-3 text-ink" data-id="element-333" data-mp="2r4ujq9s5e7n7">{Object.keys(u.enrolled).length}</td>
                <td className="px-4 py-3 text-body" data-id="element-334" data-mp="2r77b1djspucx">
                  {new Date(u.lastActive).toLocaleDateString('en-GB', {
                day: 'numeric',
                month: 'short'
              })}
                </td>
                <td className="px-4 py-3" data-id="element-335" data-mp="3jubjxtm0estz">
                  <label htmlFor={`role-${u.email}`} className="sr-only" data-id="element-336" data-mp="3osd2mdfiwq4x">Role for {u.name}</label>
                  <select id={`role-${u.email}`} value={u.role} onChange={e => setRole(u.email, e.target.value as AcademyRole)} className={`${inputClass} w-auto py-1.5 text-[13px]`} data-id="element-337" data-mp="3a401z35hqj43">
                    {ROLES.map(r => <option key={r.id} value={r.id} data-id="element-338" data-mp="bertt3gmxqj5">{r.label}</option>)}
                  </select>
                </td>
              </tr>)}
          </tbody>
        </table>
        {!users.length && <p className="px-4 py-10 text-center text-[14px] text-muted" data-id="element-339" data-mp="2eu4yhugj4gud">No users match.</p>}
      </div>
    </div>;
}